module.exports = __webpack_public_path__ + "img/Union Bank of Nigeria.6a852200.png";